import { haveValue } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import EmailInput from "./EmailInput";
import Logo from "../../assets/img/skorLogo.svg";
import Arrow from "../../assets/img/arrow-left-grey-round.svg";
import { useNavigate } from "react-router-dom";

const EmailForm = ({
  usedFor,
  email,
  onChangeHandler,
  disabled,
  emailSubmitHandler,
  companyLogo,
  from,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();

  const handleNavigate = (userType) => {
    if (userType == "tenant") navigate("/landlord/auth");
    else navigate("/tenant/auth");
  };

  return (
    <div className="formInformation">
      <div className="form_logo form_logo_mobile">
        {haveValue(companyLogo) ? (
          <>
            <img
              className="company-logo"
              src={`${process.env.REACT_APP_CDN_ENDPOINT}/${process.env.REACT_APP_CDN_CONTAINER}/${companyLogo}`}
              alt=""
            />
            <div className="d-flex align-items-center justify-content-center custom-gap-2 poweredByWrapper">
              <p className="poweredBy">{_t("poweredBy")}</p>
              <img src={Logo} alt="Powered By Logo" className="poweredByLogo" />
            </div>
          </>
        ) : (
          <img src={Logo} alt="logo" />
        )}
      </div>
      <div
        onClick={() =>
          from === "website"
            ? window.location.replace("https://skortorent.com/")
            : navigate("/auth")
        }
        className="goback-btn"
      >
        <img src={Arrow} alt="" />
        <span>{_t("goBack")}</span>
      </div>
      <div className="landlord-form-heading">
        <h2>{usedFor == "tenant" ? _t("tenant") : _t("landlord")}</h2>
      </div>
      <p className="form-inner-p">
        {usedFor == "tenant"
          ? _t(
              "helpingUsersBuildProfileForFasterApprovalsFromLandlordsAndAgentsToHelpThemMakeTheirDreamPlaceHome"
            )
          : _t("helpingLandlordsShowcasePropertiesForQuickerUserMatches")}
      </p>
      <form onSubmit={emailSubmitHandler}>
        <EmailInput
          value={email}
          onChange={onChangeHandler}
          disabled={disabled}
        />
        <button
          disabled={disabled}
          type="submit"
          className="btnNext basicInfoButton greenHover"
        >
          {_t("getStarted")}
        </button>
      </form>
      <div className="continue-other-link">
        <p>{_t("doYouWantToContinueAs")} </p>
        <span onClick={() => handleNavigate(usedFor)}>
          {usedFor == "tenant" ? _t("landlord") : _t("tenant")}{" "}
        </span>
      </div>
    </div>
  );
};

export default EmailForm;
